import { render, staticRenderFns } from "./TransactionInfo.vue?vue&type=template&id=589b2fca&scoped=true"
import script from "./TransactionInfo.vue?vue&type=script&lang=js"
export * from "./TransactionInfo.vue?vue&type=script&lang=js"
import style0 from "./TransactionInfo.vue?vue&type=style&index=0&id=589b2fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b2fca",
  null
  
)

export default component.exports